export { UMB_DROPZONE_MEDIA_TYPE_PICKER_MODAL } from './modals/dropzone-media-type-picker/dropzone-media-type-picker-modal.token.js';

export enum UmbFileDropzoneItemStatus {
	WAITING = 'waiting',
	COMPLETE = 'complete',
	NOT_ALLOWED = 'not allowed',
	CANCELLED = 'cancelled',
	ERROR = 'error',
}
